import { render, staticRenderFns } from "./TwProcessGroupListEditIpRequest.vue?vue&type=template&id=0f0efb52&scoped=true&"
import script from "./TwProcessGroupListEditIpRequest.vue?vue&type=script&lang=js&"
export * from "./TwProcessGroupListEditIpRequest.vue?vue&type=script&lang=js&"
import style0 from "./TwProcessGroupListEditIpRequest.vue?vue&type=style&index=0&id=0f0efb52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0efb52",
  null
  
)

export default component.exports